/**
* @file 运营中心-平台审核-结算审核
* */
<template>
  <div id="settlement">
    <custom-table
        addText="审核设置"
        @addFn="actionFn({ type: 'add' })"
        ref="customTable"
        has-organization="true"
        :customOptions="customOptions"
        :columns="columns"
        excel-type="PlatformAudit"
    >
      <div slot="customTable-top"
           style="padding-bottom: 16px; display: flex; justify-content: space-between; align-items: center;">
        <el-radio-group v-model="status" @change="statusChange">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button
              :label="item.value"
              v-for="item in $const.SETTLEAUDITSTATUS"
              :key="item.value"
          >
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>

        <div class="flex" v-if="mixinUserInfo.organizationType === 1">
          <img style="width: 14px; height: 14px;" src="../../../assets/img/zfb.png" alt="">
          <span style="margin-left: 5px;">账户余额：</span>
          <span style="margin: 5px; font-size: 20px; font-weight: bold;">{{ balance }}</span>元
        </div>
      </div>
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="140px">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" size="mini" @click="showSettlementDetail(row)">详情</el-button>
            <el-button
                v-if="(row.withdrawalStatus !== 2  && row.withdrawalStatus !== 1 ) || row.status !== 2 "
                type="text"
                size="mini"
                @click="passClick(row)"
            >{{ row.withdrawalStatus == 3 ? "重新转账" : "通过" }}
            </el-button>
            <span v-else>-</span>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">{{ row.created | filterTime }}</template>
        <template v-else-if="item.prop === 'updated'">
          <span v-if="row.status === 2">{{ row.updated | filterTime }}</span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'status'">
          <el-tag size="small" :type="row.status | filterConst('SETTLEAUDITSTATUS', 'type')">
            {{ row.status | filterConst('SETTLEAUDITSTATUS') }}
          </el-tag>
        </template>
        <template v-else-if="item.prop === 'withdrawalStatus'">
          <span v-if="row.withdrawalStatus == 2"> 转账成功 </span>
          <span v-else-if="row.withdrawalStatus == 3">
            转账失败
            <el-tooltip
                v-if="row.withdrawalStatus === 3"
                class="item"
                effect="dark"
                :content="row.withdrawalFailReason"
                placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <span v-else-if="row.withdrawalStatus == 1">转账中</span>
        </template>
        <template v-else-if="item.prop === 'fee'">
          <span class="util-money" v-if="row.fee || row.fee === 0">{{
              row.fee
            }}</span>
          <span v-if="!row.fee && row.fee !== 0">-</span>
        </template>
        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
        </template>
      </template>
    </custom-table>

    <el-dialog
        :visible.sync="show"
        destroy-on-close
        title="审核设置"
        width="600px"
        :before-close="() => (show = false)"
    >
      <settlementSetting
          @handClose="show = false"
          v-if="show"
      ></settlementSetting>
    </el-dialog>
    <!-- 结算详情抽屉 -->
    <el-drawer
        :visible.sync="detailVisible"
        title="结算详情"
        size="500px"
        :append-to-body="true">
      <div class="settlement-detail" v-if="currentDetail">
        <el-descriptions :column="1" border size="medium">
          <el-descriptions-item label="申请人">{{ currentDetail.name || '-' }}</el-descriptions-item>
          <el-descriptions-item label="手机号码">{{ currentDetail.phone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="身份证号">{{ currentDetail.idCard || '-' }}</el-descriptions-item>
          <el-descriptions-item label="申请结算金额">
            <span class="util-money">￥{{ currentDetail.fee || 0 }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="申请时间">{{ currentDetail.created | filterTime }}</el-descriptions-item>
          <el-descriptions-item label="处理时间">
            <span v-if="currentDetail.status === 2">{{ currentDetail.updated | filterTime }}</span>
            <span v-else>-</span>
          </el-descriptions-item>
          <el-descriptions-item label="审核状态">
            <el-tag :type="currentDetail.status == 1 ? 'warning' : (currentDetail.status == 2 ? 'success' : 'info')" size="small">
              {{ currentDetail.status | filterConst('SETTLEAUDITSTATUS') }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="转账状态">
            <el-tag type="success" size="small" v-if="currentDetail.withdrawalStatus == 2">转账成功</el-tag>
            <el-tag type="danger" size="small" v-else-if="currentDetail.withdrawalStatus == 3">转账失败</el-tag>
            <el-tag type="warning" size="small" v-else-if="currentDetail.withdrawalStatus == 1">转账中</el-tag>
            <span v-else>-</span>
          </el-descriptions-item>
          <el-descriptions-item label="失败原因" v-if="currentDetail.withdrawalStatus === 3">
            <span style="color: #f56c6c;">{{ currentDetail.withdrawalFailReason || '-' }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import settlementSetting from "./components/settlementSetting.vue";

export default {
  name: "settlement",
  components: {settlementSetting},
  data() {
    return {
      // 结算审核状态
      status: "",
      show: false,
      // 详情抽屉
      detailVisible: false,
      currentDetail: null,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/driverFlowing/cashOut",
        params: {
          status: this.status,
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "input",
            field: "name",
            name: "申请人",
            value: "",
          },
          {
            type: "input",
            field: "phone",
            name: "手机号",
            value: "",
          },

          {
            type: "select",
            field: "withdrawalStatus",
            name: "转账状态",
            value: "",
            option: this.$const.TRANSFERFAILREASON,
          },
          {
            type: "datetime",
            field: "created",
            dateProp: {
              // 类型为datetime配置搜索字段使用，默认是 startTime 和 endTime
              start: "applyTimeStart",
              end: "applyTimeEnd",
            },
            name: "申请时间",
            value: [],
          },
        ],
      },
      // 表头
      columns: [
        {prop: "name", label: "申请人"},
        {prop: "phone", label: "手机号码"},
        {prop: "idCard", label: "身份证号码"},
        {prop: "fee", label: "申请结算金额"},
        {prop: "created", label: "申请时间"},
        {prop: "updated", label: "处理时间"},
        {prop: "status", label: "审核状态"},
        {prop: "withdrawalStatus", label: "转账状态"},
      ],
      balance: 0
    };
  },
  created() {
    if (this.$route.query.status) {
      this.status = this.$route.query.status;
      this.customOptions.params.status = this.status;
    }
    if (this.mixinUserInfo.organizationType === 1) {
      this.getBalance()
    }
  },
  methods: {
    async getBalance() {
      let url = "/api/v1/manage/driverFlowing/accountBalance"
      let data = await this.$axios.get(url)
      if (data && data.code === 1) {
        this.balance = data.data || 0
      }
    },
    handClose() {
      this.rowData = {};
      this.show = false;
      this.showCancel = false;
      this.$refs.customTable.listFn();
    },
    actionFn({type, row}) {
      switch (type) {
        case "add":
          this.show = true;
          break;
      }
    },
    /**
     * 状态改变
     */
    statusChange() {
      this.customOptions.params.page = 1;
      this.customOptions.params.status = this.status;
      this.$refs.customTable.listFn();
    },
    /**
     * 通过
     */
    /**
     * 显示结算详情
     */
    showSettlementDetail(row) {
      this.currentDetail = { ...row };
      this.detailVisible = true;
    },
    async passClick(row) {
      const tipText = row.withdrawalStatus == 3 ? "重新转账" : "通过";
      this.$confirm(`确认${tipText}吗?`, `${tipText}提示`).then(async () => {
        let url = "/api/v1/manage/driverFlowing/updateStatus";
        let params = {
          id: row.id,
          driverId: row.driverId,
        };
        let data = await this.$axios.put(url, params);
        if (data && data.code === 1) {
          this.$message.success("操作成功！");
        }
        this.$refs.customTable.listFn();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.settlement-detail {
  padding: 20px;
}
</style>
